// deno-lint-ignore-file no-window-prefix
/// <reference lib="dom.iterable" />
import { assert } from "./_devmode.js";
import type { PagefindSearchFragment, PagefindSearchResults } from "./_pagefind.js";

interface Pagefind {
  search(term: string): Promise<PagefindSearchResults>;
}

interface SearchResult extends PagefindSearchFragment {
  id: string;
  score: number;
  path: string;
  summary?: string;
}

function loadPagefind(): Promise<Pagefind> {
  // @ts-expect-error PageFind only available at runtime
  return import("/pagefind/pagefind.js");
}

function updateSearchForm(q: string | boolean | null) {
  let e = document.getElementById("search-query");
  assert(e instanceof HTMLInputElement);
  if (q === true) {
    e.value = getQuery();
  } else if (q) {
    e.value = q;
  } else {
    e.value = "";
  }
}

async function searchResults(term: string): Promise<SearchResult[]> {
  let pf = await loadPagefind();
  let res = await pf.search(term);
  console.debug("received results: %o", res);
  return await Promise.all(res.results.map(async (r, i) => {
    let res = await r.data();
    console.debug("result %d: %o", i, res);
    return {
      id: r.id,
      score: r.score,
      path: res.url?.replace(/\.html$/, ""),
      summary: res.meta?.summary,
      ...res,
    };
  }));
}

function SearchResult(props: { res: SearchResult }) {
  const res = props.res;
  let thumb;

  console.log("%s: %s", res.path, res.score);
  if (res.meta?.image) {
    console.log("thumbnail image %s", res.meta.image);
    thumb = new URL(res.meta.image, window.location.href);
  }

  return (
    <div class="result" data-score={res.score}>
      {thumb
        ? (
          <a class="thumbnail" href={res.path}>
            <img class="thumbnail" src={thumb} alt={res.meta?.image_alt} />
          </a>
        )
        : null}
      <a
        class="title"
        href={res.path}
        dangerouslySetInnerHTML={res.meta?.title ?? "Untitled Page"}
      />
      {res.summary ? <p class="summary">{res.summary}</p> : null}
      {res.excerpt ? <p class="excerpt" dangerouslySetInnerHTML={res.excerpt} /> : null}
    </div>
  );
}

function SearchResultList(props: { results?: SearchResult[] }) {
  const results = props.results ?? [];
  console.debug("rendering results: %o", results);
  return (
    <div class="search-results" id="search-results">
      <p class="meta">Found {results.length} results.</p>
      {results.map((res) => <SearchResult res={res} />)}
    </div>
  );
}

function displayResults(results?: SearchResult[]) {
  let rc = document.getElementById("search-results");
  assert(rc);
  rc.replaceWith(<SearchResultList results={results} />);
}

function getQuery(): string {
  let params = new URLSearchParams(window.location.search);
  let q = params.get("query");
  if (q) {
    console.log("search query: %s", q);
    return q;
  } else {
    console.error("no search query");
    return "";
  }
}

async function refreshSearch() {
  let q = getQuery();
  if (q) {
    let res = await searchResults(q);
    displayResults(res);
  } else {
    displayResults();
  }
}

async function onSearch(evt: SubmitEvent) {
  evt.preventDefault();
  let form = evt.target;
  assert(form instanceof HTMLFormElement);
  let q = form.query.value;
  console.log("new search: %s", q);
  let search = new URLSearchParams({ query: q });
  history.pushState(null, "", "?" + search.toString());
  await refreshSearch();
}

async function onBack(_evt: PopStateEvent) {
  await refreshSearch();
  updateSearchForm(true);
}

// initialize
refreshSearch();
updateSearchForm(true);

// set up event handlers
document.getElementById("search-form")!.addEventListener("submit", onSearch);
window.addEventListener("popstate", onBack);
